<template>
    <v-row>
        <v-dialog
                v-model="dialog"
                max-width="500px"
                @keydown.esc="dialog = false"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                        color="orange"
                        dark
                        icon
                        v-bind="attrs"
                        v-on="on"
                >
                    <v-icon @click="getOrder">mdi-message</v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <p class="headline mr-16">{{ groupSetting.groupName }} 카카오톡 - 알림톡 보내기</p>
                    <p class="caption" style="clear:both">* 알림톡 전송 불가 시 LMS로 발송됩니다. <strong>[잔여건수 : {{ remain }}]</strong></p>
                </v-card-title>
                <v-card-text>
                    <v-container class="mt-n5">
                        <v-row>
                            <v-col
                                    cols="12"
                                    md="4"
                            >
                                <v-text-field
                                        label="거래처명"
                                        readonly
                                        v-model="orderAttrs.clientName"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                    cols="12"
                                    md="8"
                            >
                                <v-text-field
                                        label="연락처"
                                        readonly
                                        v-model="orderAttrs.clientPhone"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                            <v-col cols="3" class="text-center">
                                <v-btn color="primary" @click="sendAlimTalk2">
                                    시안확인
                                </v-btn>
                                <br/>
                                <div class="dates">{{ orderAttrs.alimTalk2 }}</div>
                            </v-col>

                            <v-col cols="3" class="text-center">
                                <v-btn color="primary" @click="sendAlimTalk1">
                                    생산시작
                                </v-btn>
                                <br/>
                                <div class="dates">{{ orderAttrs.alimTalk1 }}</div>
                            </v-col>

                            <v-col cols="3" class="text-center">
                                <v-btn color="primary" @click="sendAlimTalk3">
                                    납품대기
                                </v-btn>
                                <br/>
                                <div class="dates">{{ orderAttrs.alimTalk3 }}</div>
                            </v-col>

                            <v-col cols="3" class="text-center">
                                <v-btn color="primary" @click="sendAlimTalk4">
                                    미리알림
                                </v-btn>
                                <br/>
                                <div class="dates">{{ orderAttrs.alimTalk4 }}</div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="mt-n12">
                    <v-spacer></v-spacer>
                    <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog = false"
                    >
                        닫기
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'SendMessageButton',
        props: {
            orderId: {}
        },
        data: function(){
            return {
                dialog: false,
                orderAttrs: [],
                alimTalk1: null,
                alimTalk2: null,
                alimTalk3: null,
                alimTalk4: null,
                remain: 0,
                groupSetting: this.$store.getters.getGroupSetting
            }
        },
        watch: {
          dialog: async function(val) {
            if(val == true) {
                await this.getRemains()
            }
          }
        },
        methods: {
            getOrder: async function() {

                const api_url = this.$store.getters.getApiUrl + '/api/v1/order/getOrder/' + this.orderId

                if(this.orderId > 0){

                    return axios({
                        method: 'GET',
                        headers: {
                            'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                        },
                        url: api_url,
                        timeout: this.$store.getters.getApiRequestTimeLimit
                    })
                        .then(response => {

                            this.orderAttrs.clientName = response.data.clientName
                            this.orderAttrs.clientPhone = response.data.clientPhone
                            if(response.data.alimTalk1){
                                this.orderAttrs.alimTalk1 = this.$day(response.data.alimTalk1).format('YYYY-MM-DD hh:mm:ss')
                                this.alimTalk1 = true
                            }else{
                                this.orderAttrs.alimTalk1 = '미발송'
                            }
                            if(response.data.alimTalk2){
                                this.orderAttrs.alimTalk2 = this.$day(response.data.alimTalk2).format('YYYY-MM-DD hh:mm:ss')
                                this.alimTalk2 = true
                            }else{
                                this.orderAttrs.alimTalk2 = '미발송'
                            }
                            if(response.data.alimTalk3){
                                this.orderAttrs.alimTalk3 = this.$day(response.data.alimTalk3).format('YYYY-MM-DD hh:mm:ss')
                                this.alimTalk3 = true
                            }else{
                                this.orderAttrs.alimTalk3 = '미발송'
                            }
                            if(response.data.alimTalk4){
                                this.orderAttrs.alimTalk4 = this.$day(response.data.alimTalk4).format('YYYY-MM-DD hh:mm:ss')
                                this.alimTalk4 = true
                            }else{
                                this.orderAttrs.alimTalk4 = '미발송'
                            }

                        })

                }else{

                    alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                    return false

                }
            },
            sendAlimTalk: function(templateNo, templateCode) {

                if(templateNo == 1 && this.alimTalk1 == true){
                    if(!confirm('이미 발송한 메세지입니다.\n재발송 하시겠습니까?')){
                        return false
                    }
                }else if(templateNo == 2 && this.alimTalk2 == true){
                    if(!confirm('이미 발송한 메세지입니다.\n재발송 하시겠습니까?')){
                        return false
                    }
                }else if(templateNo == 3 && this.alimTalk3 == true){
                    if(!confirm('이미 발송한 메세지입니다.\n재발송 하시겠습니까?')){
                        return false
                    }
                }else if(templateNo == 4 && this.alimTalk4 == true){
                    if(!confirm('이미 발송한 메세지입니다.\n재발송 하시겠습니까?')){
                        return false
                    }
                }

                const api_url = this.$store.getters.getApiUrl + '/api/v1/alimtalk/sendAlimTalk/' + this.orderId + '/' + templateCode

                return axios({
                    method: 'POST',
                    headers: {
                        'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                    },
                    url: api_url,
                    data: {
                        templateNo: templateNo
                    },
                    timeout: this.$store.getters.getApiRequestTimeLimit
                })
                    .then(async response => {

                        const res = response.data

                        if(res.code == 0){
                            alert(res.message)
                            await this.getRemains()
                            await this.getOrder()
                            this.$forceUpdate()
                        }else{
                            alert(res.message)
                            return false
                        }

                    })

            },
            getRemains: async function() {

                if(this.dialog == false){
                    return false
                }

                const api_url = this.$store.getters.getApiUrl + '/api/v1/alimtalk/getRemains'

                return axios({
                    method: 'POST',
                    headers: {
                        'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                    },
                    url: api_url,
                    timeout: this.$store.getters.getApiRequestTimeLimit
                })
                    .then(async response => {

                        const res = response.data

                        if(res.code == 0){
                            this.remain = res.list.ALT_CNT
                            this.$forceUpdate()
                        }

                    })

            },
            sendAlimTalk1: async function() {
                await this.sendAlimTalk(1, 'begin')
            },
            sendAlimTalk2: async function() {
                await this.sendAlimTalk(2, 'checkDesign')
            },
            sendAlimTalk3: async function() {
                await this.sendAlimTalk(3, 'beforeDelivery')
            },
            sendAlimTalk4: async function() {
                await this.sendAlimTalk(4, 'reminder')
            }
        },
        mounted: async function() {
            await this.getOrder()
        }
    }
</script>

<style>
.dates {
    margin-top: .8em;
    line-height: 1em;
}
</style>